const COLUMNS = [
  {
    title: "Company",
    links: [
      { label: "About Us", href: "#about" },
      { label: "Global Presence", href: "#global" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Workplace Collaboration", href: "#solutions" },
      { label: "Communication", href: "#solutions" },
      { label: "Project Management", href: "#solutions" },
      { label: "Business Workflows", href: "#solutions" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms of Service", href: "#" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-white border-t border-gray-100">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
      <div>
        <a href="#top" className="flex items-center gap-2.5">
          <span className="grid place-items-center h-9 w-9 rounded-xl bg-lark-blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M4 20V4l7 8 2-3 7 11H4Z" fill="white" />
            </svg>
          </span>
          <span className="font-display text-lg font-semibold text-lark-ink">
            Lark<span className="text-lark-blue">.</span>
          </span>
        </a>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-lark-muted">
          Lark Technologies Pte. Ltd. — a Singapore-headquartered enterprise software
          company and a subsidiary of ByteDance.
        </p>
      </div>

      {COLUMNS.map((col) => (
        <div key={col.title}>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-lark-ink">
            {col.title}
          </p>
          <ul className="mt-4 space-y-3">
            {col.links.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="text-sm text-lark-muted hover:text-lark-blue transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="border-t border-gray-100">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-lark-muted">
          © {new Date().getFullYear()} Lark Technologies Pte. Ltd. All rights reserved.
        </p>
        <p className="text-xs text-lark-muted">Headquartered in Singapore · A ByteDance company</p>
      </div>
    </div>
  </footer>
);
